import React from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { getBrokerInformation } from "../store/broker";
import translations from "../utils/translations";
const UserAdminNavigation = (props) => {
  const styles = {
    className: "list-group-item list-group-item-action",
    activeClassName:
      "list-group-item list-group-item-light list-group-item-action active",
  };

  const broker = useSelector(getBrokerInformation);
  const languagepreference = broker.information.languagepreference;

  const links = [
    {
      className:
        props.active === "user" ? styles.activeClassName : styles.className,
      to: "/useradmin/user",
      name: translations[languagepreference].personalInformation,
    },
  
    {
      className:
        props.active === "bmscreds" ? styles.activeClassName : styles.className,
      to: "/useradmin/bmscreds",
      name: translations[languagepreference].bmsCredentials,
    },
    {
      className:
        props.active === "insuredcreds"
          ? styles.activeClassName
          : styles.className,
      to: "/useradmin/insuredcreds",
      name: translations[languagepreference].insurerCredentials,
    },
  ];

  return (
    <div>
      <ul className="list-group" style={{ listStyle: "none" }}>
        {links.map((link, index) => (
          <li key={index} style={{ fontFamily: "GibsonSemiBd" }}>
            <Link
              style={{ paddingLeft: "30px" }}
              className={link.className}
              role="button"
              to={link.to}
            >
              {link.name}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default UserAdminNavigation;
